import './App.css';
import { observer, Provider } from 'mobx-react';
import { configure } from 'mobx';
import Routes from './routes';
import store from '../store';
import { BrowserRouter } from 'react-router-dom';

/* added animation */
import gsap from 'gsap';
import { CustomEase } from 'gsap/CustomEase';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin'
 
function registerGSAPPlugins () {
  gsap.registerPlugin(MotionPathPlugin);
  gsap.registerPlugin(CustomEase);
}

registerGSAPPlugins();

configure({
  enforceActions: 'never',
});

function App() {
  return (
       <Provider store={store}>
          <BrowserRouter>
            <Routes store={store} />
          </BrowserRouter>
      </Provider>
  );
}

export default observer(App);